var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonthlyChallenge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 61,
    viewBox: "0 0 98 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.2202 4.35297L21.686 4.79216L41.1569 36.9264L91.7373 38.6832C91.7373 38.6832 94.8116 22.8723 91.3713 14.7472C87.9309 6.62213 79.2202 4.35297 79.2202 4.35297Z",
    fill: "url(#paint0_radial_675_3936)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1505 35.4624L86.6865 35.7552C86.6865 35.7552 88.7361 28.5818 87.1989 18.6267C86.3937 13.6492 82.8802 8.0129 77.3171 5.96334C74.1695 4.86536 71.5343 4.49936 70.5828 4.42616L76.8778 4.35297C83.9781 6.25613 89.2485 13.1368 89.6144 22.8723C89.9072 33.3397 88.1505 35.4624 88.1505 35.4624Z",
    fill: "#8D001A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8226 37.5852L58.7979 38.5368C58.7979 38.5368 58.7979 38.1708 58.8711 37.5852C59.2371 33.4129 60.1886 17.4555 53.8203 11.2336C50.3068 7.7933 47.1593 5.74374 44.8169 4.57256H46.2077C49.3552 5.81693 53.3812 7.8665 55.3575 10.7213C60.2619 17.8215 59.8226 37.5852 59.8226 37.5852Z",
    fill: "#8D001A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3385 37.9512C69.1921 38.61 69.1189 38.976 69.1189 38.976L68.0941 39.4152C68.0941 39.4152 68.2405 38.8296 68.3869 37.878C69.2653 33.2665 71.5345 19.1391 67.8745 12.6244C65.825 9.1109 59.5299 6.40254 55.5771 4.49937H57.3339C60.6279 6.76854 66.4106 9.47689 68.6065 12.112C72.7789 17.0896 70.1437 33.6325 69.3385 37.9512Z",
    fill: "#8D001A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4399 36.048C79.4399 36.048 82.441 21.9939 79.0739 14.0884C75.6335 6.18293 64.9465 4.42616 64.9465 4.42616H67.2157C71.0953 5.89014 77.8295 8.52529 79.6595 13.3564C82.9535 22.3599 79.4399 36.048 79.4399 36.048Z",
    fill: "#8D001A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.498 4.79214C40.7176 5.67053 44.7436 16.5771 51.3315 16.7967C57.9193 17.0163 87.3453 16.7967 83.6853 12.9172C80.0986 9.11087 73.2911 3.91376 62.8969 5.23134C52.5026 6.62211 40.498 4.79214 40.498 4.79214Z",
    fill: "#FF9CA1"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M47.818 15.9916C47.818 15.9916 86.9061 11.8192 88.5897 13.7224C90.2733 15.6256 88.8825 36.3408 88.3701 36.2676C87.7845 36.1212 46.7932 37.2924 46.7932 37.2924L47.818 15.9916Z",
    fill: "url(#paint1_linear_675_3936)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9488 4.35296C70.9488 4.35296 80.7574 6.84171 83.6854 12.112C88.1505 19.9443 87.2721 32.6809 86.1741 33.5593C85.0761 34.4376 55.2843 34.1449 54.9915 34.0717C54.7719 33.9985 47.0128 33.8521 47.0128 33.8521L45.9148 36.6336L91.4444 36.8532L92.9084 22.1403C92.9084 22.1403 88.7361 8.89128 84.637 6.32932C80.5378 3.76736 70.9488 4.35296 70.9488 4.35296Z",
    fill: "#BE2F55"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0527 35.682C87.0527 35.682 91.4446 19.7979 83.9051 10.3553C79.074 4.42615 70.9489 4.35296 70.9489 4.35296L64.9466 4.42616L60.6279 4.49935C60.6279 4.49935 62.7507 2.01059 66.557 1.3518C68.387 0.985811 72.4129 0.912613 74.8285 0.912613C77.976 0.912613 81.4164 1.05901 83.5391 1.7178C101.473 7.4273 95.3973 35.5356 95.3973 35.5356L87.0527 35.682Z",
    fill: "url(#paint2_linear_675_3936)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8589 35.0233C90.8589 35.0233 91.1517 23.531 93.4208 23.6774C95.7632 23.8238 95.4704 34.9501 95.4704 34.9501L90.8589 35.0233Z",
    fill: "#FF3355"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M87.0527 35.682C87.0527 35.682 91.4446 19.7979 83.9051 10.3553C79.074 4.42615 70.9489 4.35296 70.9489 4.35296L64.9466 4.42615L60.6279 4.49935C60.6279 4.49935 63.1899 1.791 66.7766 1.2786C70.8757 0.693014 81.7091 1.93739 86.7599 9.33047C93.4941 19.2123 89.3218 35.682 89.3218 35.682H87.0527Z",
    fill: "url(#paint3_linear_675_3936)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45958 35.8284C3.45958 35.8284 1.99561 25.4342 1.99561 21.5547C1.99561 12.478 6.89993 4.64575 20.8077 4.64575C34.7887 4.64575 38.6682 9.98927 41.1569 18.3339C42.5477 23.0186 41.0838 35.4624 41.0838 35.4624L3.45958 35.8284Z",
    fill: "url(#paint4_radial_675_3936)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.47 10.2089L32.8855 38.0976H33.6175L31.2751 10.7944L30.47 10.2089Z",
    fill: "#8D001A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0589 17.8215C38.3754 13.5028 29.0791 2.52299 19.4901 4.13336C9.90105 5.67054 6.09471 14.6008 5.43592 18.6999C4.85033 22.7259 7.11948 36.1212 7.11948 36.1212L9.90103 34.8036C9.90103 34.8036 3.53276 18.0411 12.1702 10.1357L17.3673 42.3431L18.3189 42.2699C16.1229 31.7293 13.7806 18.3339 13.2682 9.25728C14.0734 8.67169 14.9518 8.0861 15.9766 7.64691C18.0261 6.76852 19.8561 6.40252 21.6861 6.40252L25.0532 42.4895L26.2976 41.6111C23.9552 31.8025 22.784 17.3091 22.5644 6.47572C30.1039 6.98811 35.0814 14.308 36.765 19.4319C38.9609 26.0198 37.2042 35.682 37.2042 35.682L39.4002 36.1212C39.4002 36.1212 41.7425 22.1403 40.0589 17.8215Z",
    fill: "#8D001A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58338 34.6572C8.58338 34.6572 4.70384 7.8665 21.0272 8.37889C37.2773 8.96448 38.4485 25.0682 38.4485 25.0682C38.4485 25.0682 38.1557 4.64575 20.222 4.35295C2.2883 3.98696 6.53382 35.8284 6.53382 35.8284L8.58338 34.6572Z",
    fill: "#BE2F55"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3764 35.0965L40.4981 60.7892H9.90096L3.45947 35.8284L41.3764 35.0965Z",
    fill: "url(#paint5_radial_675_3936)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3764 35.0965L40.4981 60.7892H9.90096L3.45947 35.8284L41.3764 35.0965Z",
    fill: "url(#paint6_radial_675_3936)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3674 42.3431L20.2222 60.6428L20.881 60.5696L18.319 42.2699L17.3674 42.3431Z",
    fill: "#8D001A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4936 60.7892H27.3956L25.1996 43.4411L25.0532 42.4895L25.5656 42.2699L25.712 43.4411L28.4936 60.7892Z",
    fill: "#8D001A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6106 58.3737C15.6106 58.3737 13.6342 43.5143 14.1466 43.4411C14.5858 43.2947 31.0555 43.4411 31.0555 43.7339C31.0555 44.0999 33.4711 59.1056 33.4711 59.1056L35.1546 58.9592L33.0319 41.6111L11.8774 42.0503L15.6106 58.3737Z",
    fill: "#8D001A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8301 60.7892C15.8301 60.7892 13.7073 44.9783 15.8301 44.7587C17.9528 44.4659 30.3966 43.7339 30.543 44.8319C30.7626 45.8566 33.9833 60.7892 33.9833 60.7892L37.2773 59.1788C37.2773 59.1788 35.7401 41.4647 35.3741 41.3915C34.9349 41.2451 9.16895 39.9276 9.16895 39.9276L15.8301 60.7892Z",
    fill: "#BE2F55"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9754 42.0503L15.8302 60.7892H8.2175L4.04517 42.3431L12.9754 42.0503Z",
    fill: "url(#paint7_linear_675_3936)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M12.9754 42.0503L15.8302 60.7892H8.2175L4.04517 42.3431L12.9754 42.0503Z",
    fill: "url(#paint8_linear_675_3936)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M12.9752 42.0503L15.83 60.7892H13.7804L11.1453 42.1235L12.9752 42.0503Z",
    fill: "url(#paint9_linear_675_3936)"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3764 35.0965L94.1527 35.5356L86.6865 60.7892H40.498L41.3764 35.0965Z",
    fill: "url(#paint10_radial_675_3936)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8712 41.9771C58.8712 41.9771 58.7248 42.7091 58.6516 43.8071C58.3588 45.9299 57.9196 49.4434 57.4804 52.0054C57.0412 54.6405 55.9433 58.52 55.2845 60.7892H54.9917L57.9928 43.8071L58.2856 42.1235L58.8712 41.9771Z",
    fill: "#8D001A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1438 41.3183C70.1438 41.3183 69.9242 42.2699 69.6314 43.6607C69.119 46.1495 68.387 49.9558 68.021 53.1033C67.7282 55.4457 67.2158 58.4468 66.7766 60.7892H66.4106L68.5334 43.6607L68.753 41.7575L70.1438 41.3183Z",
    fill: "#8D001A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6347 42.1235L78.4151 43.6607L75.9996 60.7892H75.2676C76.2924 54.8601 77.6831 46.9547 78.3419 43.6607C78.4883 42.8555 78.5615 42.2699 78.6347 42.1235Z",
    fill: "#8D001A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M50.38 50.395C50.5264 50.1022 51.6976 44.0267 52.7223 43.8071C53.7471 43.6607 60.335 43.8071 60.335 43.8071C60.335 43.8071 82.4411 43.2947 82.5875 43.9535C82.8071 44.5391 81.3431 58.886 81.3431 58.886C81.3431 58.886 84.4906 56.9829 84.4906 56.6169C84.4906 56.3241 86.3206 40.5132 86.3206 40.5132L49.3552 41.0255L50.38 50.395Z",
    fill: "#8D001A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5984 59.0324C47.5984 59.0324 51.9903 46.0031 52.7223 45.1979C53.3811 44.4659 57.4802 45.2711 57.4802 45.2711C57.4802 45.2711 65.2393 54.4941 66.9229 54.4941C68.6797 54.4941 78.1955 44.5391 78.1955 44.5391C78.1955 44.5391 81.7822 43.5875 82.0018 44.3195C82.2214 45.1247 81.1966 60.7892 81.1966 60.7892L85.003 42.3431L49.1356 41.9771L47.5984 59.0324Z",
    fill: "#BE2F55"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0513 42.0503L81.1965 60.7892H88.8092L92.9815 42.3431L84.0513 42.0503Z",
    fill: "url(#paint11_linear_675_3936)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M84.0513 42.0503L81.1965 60.7892H83.2461L85.8813 42.1235L84.0513 42.0503Z",
    fill: "url(#paint12_linear_675_3936)"
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6693 60.7892L41.3765 35.0964L52.4295 34.95L49.282 60.7892H41.6693Z",
    fill: "url(#paint13_linear_675_3936)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1083 42.6359C42.1083 42.6359 41.8156 52.8105 43.06 52.8105C44.3043 52.8105 49.0622 52.1518 49.0622 52.1518C49.0622 52.1518 51.917 41.9771 50.8922 42.0503C49.8674 42.1235 42.1083 42.6359 42.1083 42.6359Z",
    fill: "#FF3355"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8359 35.316C30.8359 35.316 33.8371 60.7892 33.9835 60.7892C34.1299 60.7892 41.6693 60.7892 41.6693 60.7892L41.3765 35.0965L30.8359 35.316Z",
    fill: "url(#paint14_linear_675_3936)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M30.8359 35.316C30.8359 35.316 33.8371 60.7892 33.9835 60.7892C34.1299 60.7892 41.6693 60.7892 41.6693 60.7892L41.3765 35.0965L30.8359 35.316Z",
    fill: "url(#paint15_linear_675_3936)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M31.7144 42.6359C31.7144 42.6359 34.5691 52.2982 37.7898 51.4198C41.0106 50.4682 41.889 42.9287 41.889 42.9287L31.7144 42.6359Z",
    fill: "url(#paint16_linear_675_3936)"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1568 35.8284C41.1568 35.8284 44.524 19.3587 37.4969 10.3553C32.8122 4.42616 21.5396 0.693021 21.5396 0.693021C21.5396 0.693021 32.1534 0.546619 35.8865 1.7178C53.747 7.4273 48.7695 35.5356 48.7695 35.5356L41.1568 35.8284Z",
    fill: "url(#paint17_linear_675_3936)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3281 35.0232C42.3281 35.0232 43.4261 23.0918 45.8417 23.3114C48.2572 23.4578 48.6232 35.0232 48.6232 35.0232H42.3281Z",
    fill: "#FF3355"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M28.2739 2.37659C28.2739 2.37659 39.2537 4.42615 41.6693 17.2359C44.0849 29.9725 42.1817 34.8768 42.1817 34.8768C43.2797 21.2619 38.7414 10.4285 28.2739 2.37659Z",
    fill: "url(#paint18_radial_675_3936)"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1816 34.8768L38.0824 35.0232C38.0824 35.0232 38.5949 29.3137 37.9361 22.9454C37.4237 18.0411 32.4461 5.15814 21.9055 5.45094C13.7805 5.74373 10.0473 11.5264 8.65656 14.6008C4.99662 23.165 9.90091 35.2428 9.90091 35.2428L3.38624 35.5356C3.38624 35.5356 -1.37167 21.3351 2.43467 12.6976C5.50902 5.96332 9.68133 1.6446 21.5395 0.693015C24.8335 0.473419 32.2266 3.40137 37.0577 9.33047C43.5724 17.4555 42.4012 33.4861 42.1816 34.8768Z",
    fill: "url(#paint19_linear_675_3936)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5835 8.45209C7.41232 11.746 4.85039 16.9431 5.36278 22.4331C5.87517 27.923 6.24113 31.8757 6.24113 31.8757C5.80194 34.2913 4.85036 34.7304 3.09359 31.8025C1.99561 26.9714 0.312047 18.9927 2.874 13.21C3.97199 10.7944 5.21636 8.81808 6.89994 7.06131C8.51031 7.20771 9.09589 7.06131 8.5835 8.45209Z",
    fill: "#FF3355"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M21.9055 5.45094C13.7804 5.74373 10.0473 11.5264 8.65654 14.6008C4.9966 23.165 9.90089 35.2428 9.90089 35.2428L6.97294 35.3892C6.97294 35.3892 2.87382 21.2619 7.26575 12.9172C11.2185 5.37774 21.9055 5.45094 21.9055 5.45094Z",
    fill: "url(#paint20_linear_675_3936)"
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M97.154 34.8768C97.154 34.8768 95.69 39.8543 95.5436 40.0007C95.4704 40.0739 94.6653 40.2203 94.5921 40.2935C94.5189 40.2935 93.8601 42.7091 93.7137 42.7823C93.6405 42.9287 40.9374 42.9287 40.9374 42.9287L3.3864 42.4895L2.7276 40.1471L1.55643 39.7079L0.751221 34.8768H97.154Z",
    fill: "url(#paint21_linear_675_3936)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M0.751221 34.8768L1.55643 39.7079L2.7276 40.1471L3.3864 42.4895L40.9374 42.9287H41.8889L41.8158 40.2935L41.3034 39.9275L41.157 34.8768H0.751221Z",
    fill: "url(#paint22_linear_675_3936)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9,
    d: "M1.5564 39.708L95.5436 40.0008L94.592 40.2936H41.8157L2.72756 40.1472L1.5564 39.708Z",
    fill: "url(#paint23_linear_675_3936)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M1.5564 39.708C1.99559 39.7812 95.1776 39.9276 95.1776 39.9276C95.1776 39.9276 73.5108 42.4163 59.1638 42.2699C44.8169 42.1967 2.72756 40.1472 2.72756 40.1472L1.5564 39.708Z",
    fill: "url(#paint24_linear_675_3936)"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M41.157 34.8768C41.7426 35.0964 68.0942 35.682 73.4377 35.8284C78.708 35.9016 97.154 34.8768 97.154 34.8768H41.157Z",
    fill: "#FFE016"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M0.751221 34.8768L41.3034 36.2676L97.154 34.8768H0.751221Z",
    fill: "url(#paint25_radial_675_3936)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2642 28.8013L65.825 27.2642L61.7259 27.1178C61.7259 27.1178 60.5547 30.4117 58.7247 31.5097C56.8216 32.6077 54.04 32.9737 54.04 32.9737L55.4308 42.9287L66.4106 51.7126L66.2642 28.8013Z",
    fill: "#D42F55"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6312 27.4106C69.3384 27.1178 66.63 27.1178 66.3372 27.4838C65.8248 28.5086 61.5793 33.8521 56.5286 34.3645L57.1874 42.1967C57.1874 42.1967 65.7516 51.493 66.4104 51.7126C66.996 51.9322 69.2652 52.0786 69.2652 52.0786L75.9262 42.5627L76.8778 34.8037C72.4859 33.7789 69.6312 27.4106 69.6312 27.4106Z",
    fill: "url(#paint26_linear_675_3936)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6313 27.4106C69.5581 27.4106 69.5581 27.4106 69.5581 27.4106C66.8497 30.2653 63.7022 33.8521 59.2371 34.6573L59.969 42.4895C59.969 42.4895 67.5817 51.859 69.1189 52.0054C70.7293 52.0786 78.7079 42.8555 78.7079 42.8555L79.6595 35.0233C75.1944 34.0717 72.1933 30.4117 69.6313 27.4106Z",
    fill: "url(#paint27_linear_675_3936)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M60.7743 41.3915C60.8475 41.6843 67.8746 51.2734 69.6314 51.0538C71.4613 50.9074 78.6348 42.1235 78.6348 42.1235C78.6348 42.1235 71.2417 45.7103 69.2654 43.8071C67.2158 41.9771 67.9478 36.3408 65.1662 36.5604C62.3847 36.78 59.5299 36.9264 60.7743 41.3915Z",
    fill: "url(#paint28_linear_675_3936)"
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5569 49.8826C67.7281 51.0538 68.6796 51.9322 69.1188 52.0054C69.558 52.0054 70.4364 51.3466 71.4612 50.395C69.9972 51.859 68.3137 51.5662 66.5569 49.7362C66.5569 49.8094 66.5569 49.8826 66.5569 49.8826Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6312 27.4106C69.558 27.4106 69.558 27.4106 69.558 27.4106C67.0692 30.1189 64.3609 33.6325 60.335 34.7305C62.8237 38.4636 68.6064 39.9276 69.4848 46.8815C70.29 53.8353 76.8047 38.61 79.513 36.1212L79.6595 35.0233C75.1943 34.0717 72.1932 30.4117 69.6312 27.4106Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M69.8509 28.5818C67.1425 31.4365 68.6797 49.5166 70.2168 49.663C71.754 49.7362 78.1223 42.4163 78.1223 42.4163L78.5615 35.682C74.0964 34.7305 69.8509 28.5818 69.8509 28.5818Z",
    fill: "url(#paint29_linear_675_3936)"
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8507 34.0717C68.094 34.0717 67.362 36.1212 67.5816 36.9996C67.8744 37.9512 69.1188 38.976 69.1188 38.976C69.1188 38.976 68.0208 43.4411 68.094 43.6607C68.094 43.8803 72.0467 44.3195 72.0467 44.3195L70.5827 38.976C70.5827 38.976 72.0467 37.4388 72.0467 36.3408C72.0467 35.2428 71.3147 33.9985 69.8507 34.0717Z",
    fill: "url(#paint30_linear_675_3936)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2369 34.6572C59.1637 34.7304 56.5286 34.3645 56.5286 34.3645L57.1874 42.1967L59.9689 42.4895L59.2369 34.6572Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M69.6313 27.4106C69.6313 27.4106 68.0209 31.8025 65.5321 33.4861C63.0434 35.1697 59.2371 34.6573 59.2371 34.6573C63.7022 33.8521 66.8497 30.2653 69.5581 27.4106H69.6313Z",
    fill: "url(#paint31_radial_675_3936)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M78.7077 42.8555H78.6345C78.1953 43.3679 71.461 51.2002 69.4115 51.9322L69.1187 52.0053C69.1187 52.0053 70.8754 45.4907 73.657 43.7339C76.4385 41.9771 78.7077 42.8555 78.7077 42.8555Z",
    fill: "url(#paint32_radial_675_3936)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M4.04517 42.4895C4.04517 42.4895 5.36276 43.8803 7.99792 43.7339C10.5599 43.5875 11.2919 42.5627 11.2919 42.5627L4.04517 42.4895Z",
    fill: "url(#paint33_linear_675_3936)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M72.4861 1.42502C72.7057 1.42502 85.8083 1.93741 89.395 11.0141C93.055 20.0907 89.9806 32.5345 89.9806 32.5345C89.9806 32.5345 91.8838 16.3576 87.0527 9.62328C81.7091 2.2302 72.4861 1.42502 72.4861 1.42502Z",
    fill: "url(#paint34_radial_675_3936)"
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8158 43.6607L41.6694 60.7892C41.6694 60.7892 42.1086 57.2757 42.7674 52.2981C43.4994 47.3938 41.8158 43.6607 41.8158 43.6607Z",
    fill: "#FFE016"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1476 6.32932C16.6353 6.40251 9.75458 9.03767 7.92462 12.844C6.09465 16.6503 4.99663 25.8734 5.87501 26.3858C6.6802 26.8982 7.63181 27.8498 7.41221 26.7518C7.19262 25.6538 6.89983 19.9443 9.75458 14.0152C12.6093 8.01289 17.1476 6.32932 17.1476 6.32932Z",
    fill: "#D42F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7021 4.57255C63.7021 4.57255 75.3408 -2.82052 84.7102 8.81808C94.1528 20.3835 87.4186 34.3645 87.4186 34.3645C87.4186 34.3645 89.9073 16.9431 83.6122 10.6481C77.2439 4.27976 63.7021 4.57255 63.7021 4.57255Z",
    fill: "#D42F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8308 60.4964C80.904 60.4964 82.4411 60.6428 82.7339 59.984C83.0267 59.3252 85.9547 43.1483 85.3691 43.0751C84.7835 43.0751 82.1483 43.0751 82.1483 43.2947C82.1483 43.4411 80.3184 60.35 80.8308 60.4964Z",
    fill: "#D42F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0278 42.9287C86.0278 42.9287 86.7598 48.3454 89.029 48.1258C91.3714 47.9794 92.9817 42.7091 92.6889 42.7091C92.4694 42.7091 86.0278 42.9287 86.0278 42.9287Z",
    fill: "#FF3355"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5298 34.5841C59.603 34.5841 62.6773 33.5593 63.9949 32.6077C65.2393 31.6561 68.2404 28.8014 68.2404 28.8746C68.1672 28.9477 66.0445 32.0221 64.1413 32.9737C62.2381 33.9985 59.5298 34.5841 59.5298 34.5841Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5569 27.4838C66.7033 27.7034 62.897 31.8025 62.3114 32.2417C61.7258 32.6809 63.4094 32.5345 64.2146 32.0221C64.9465 31.5829 69.1921 27.557 68.9725 27.557C68.6797 27.557 66.5569 27.4838 66.5569 27.4838Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M59.6763 44.3195C59.7495 44.4659 66.191 51.6394 66.7034 51.7126C67.2158 51.7126 68.4601 52.0786 68.2405 51.7858C67.9477 51.5662 60.9939 44.0267 60.5547 44.0267C60.1887 44.0267 59.6763 44.3195 59.6763 44.3195Z",
    fill: "url(#paint35_linear_675_3936)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M30.9823 3.98696C30.4455 4.52375 29.9087 5.18253 29.3719 5.96332C29.0791 6.40251 28.9328 6.91491 28.7864 7.4273C27.542 6.54891 26.1512 5.96332 24.614 5.67052C25.1996 4.13335 25.7852 2.66938 26.2976 1.64459C27.7616 2.15698 29.3719 2.96217 30.9823 3.98696Z",
    fill: "url(#paint36_radial_675_3936)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M39.4002 13.21C38.3022 14.308 37.131 15.6256 36.1062 16.7235C35.667 15.6256 35.0814 14.5276 34.4226 13.4296C35.2278 11.8924 36.1062 10.1356 36.6918 8.89127C36.8382 9.03766 36.9602 9.18406 37.0578 9.33046C38.0094 10.4284 38.7414 11.746 39.4002 13.21Z",
    fill: "url(#paint37_radial_675_3936)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M47.0128 12.6244C45.6952 12.1852 44.4509 11.8924 43.4993 11.6728C39.9857 11.0872 39.6197 13.21 39.6197 13.21L36.9114 8.67168C36.9114 8.67168 40.4981 6.91491 43.4993 6.76851C45.0364 8.52528 46.1344 10.5016 47.0128 12.6244Z",
    fill: "url(#paint38_radial_675_3936)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M39.3269 3.25498C38.0825 3.18178 36.6186 3.10858 35.1546 3.03538C31.4946 3.03538 30.9823 3.76737 30.9823 3.98696C30.9823 3.98696 26.6635 1.7178 26.5171 1.6446C26.2975 1.4982 26.5171 1.6446 29.4451 1.13221C29.8843 1.08341 30.4211 1.03461 31.0555 0.985809C31.1043 0.985809 31.1286 0.985809 31.1286 0.985809C33.0318 1.13221 34.7886 1.3518 35.8866 1.7178C37.1553 2.15699 38.3021 2.66939 39.3269 3.25498Z",
    fill: "url(#paint39_radial_675_3936)"
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5937 6.18294C35.0813 6.25614 39.766 14.4544 40.7176 14.308C41.596 14.1616 37.7897 5.96334 35.5937 6.18294Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2917 42.5627C11.2917 42.5627 12.8289 53.9085 13.6341 54.1281C14.4393 54.3477 14.8053 53.9817 14.8053 53.9817L12.9753 42.7823L11.2917 42.5627Z",
    fill: "#D42F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M49.282 60.7892C49.282 60.7892 62.2382 54.3477 67.4353 55.0065C72.6324 55.7385 81.1966 60.7892 81.1966 60.7892H49.282Z",
    fill: "#FF9CA1"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M4.04507 42.4895C3.97187 42.6359 7.48542 51.493 7.85142 54.9333C8.29061 58.3004 8.21741 60.7892 8.21741 60.7892L4.04507 42.4895Z",
    fill: "url(#paint40_radial_675_3936)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M56.5286 34.3645C56.5286 34.3645 57.2606 39.1224 58.1389 38.8296C59.0173 38.5368 59.4565 34.584 59.2369 34.6572C59.0905 34.7304 56.5286 34.3645 56.5286 34.3645Z",
    fill: "url(#paint41_linear_675_3936)"
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6596 35.0232L78.708 42.8555L78.9276 35.4624L79.6596 35.0232Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9558 35.0964C93.0549 35.0232 97.1541 34.8768 97.1541 34.8768L82.7339 34.8036C82.7339 34.8036 85.003 35.2428 88.9558 35.0964Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9038 3.40137C81.2698 3.54776 86.5401 6.91491 87.7113 9.62326C88.8825 12.3316 89.2485 13.7224 89.2485 13.7224L86.5401 9.03767L80.9038 3.40137Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_675_3936",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.9919 5.6376) rotate(2.0756) scale(28.1129 28.1129)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE5411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B42B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_675_3936",
    x1: 74.8283,
    y1: 9.90655,
    x2: 75.2773,
    y2: 31.5251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE376D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_675_3936",
    x1: 124.18,
    y1: 13.3557,
    x2: 68.1014,
    y2: 56.9871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#FC9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#FE8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#FC9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_675_3936",
    x1: 86.9048,
    y1: 42.723,
    x2: 39.4536,
    y2: 81.3323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_675_3936",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.6204 52.7732) rotate(-9.87979) scale(40.8438 40.8438)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE5411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B42B00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_675_3936",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.4282 47.9633) scale(16.1916)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE5411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B42B00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_675_3936",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.8603 62.251) rotate(5.87722) scale(17.4067)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE5411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B42B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_675_3936",
    x1: -15.4045,
    y1: 71.6687,
    x2: -1.02715,
    y2: 30.4218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#FC9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#FE8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#FC9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_675_3936",
    x1: -47.2512,
    y1: 61.355,
    x2: 19.0238,
    y2: 30.9788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_675_3936",
    x1: 1.1331,
    y1: 61.8564,
    x2: -18.1527,
    y2: 62.2582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_675_3936",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.1221 66.4951) rotate(1.58444) scale(18.4253 18.4253)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE5411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B42B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_675_3936",
    x1: 112.433,
    y1: 71.6687,
    x2: 98.0552,
    y2: 30.4219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#FC9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#FE8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#FC9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_675_3936",
    x1: 82.0983,
    y1: 60.9583,
    x2: 86.6074,
    y2: 60.9412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_675_3936",
    x1: 40.258,
    y1: 80.8157,
    x2: 13.6221,
    y2: 58.2005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#FC9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#FE8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_675_3936",
    x1: 21.2293,
    y1: 34.9742,
    x2: 38.087,
    y2: 35.0308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#FC9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#FE8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_675_3936",
    x1: -6.52615,
    y1: 42.4456,
    x2: 51.5053,
    y2: 8.46346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_675_3936",
    x1: 40.608,
    y1: 42.0576,
    x2: 40.5607,
    y2: 58.9578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_675_3936",
    x1: 21.5044,
    y1: 0.714248,
    x2: 49.4034,
    y2: 0.714248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#FC9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#FE8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#FC9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_675_3936",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.4619 10.6598) rotate(-16.1101) scale(28.3262 28.3262)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_675_3936",
    x1: 35.1077,
    y1: 51.0311,
    x2: -16.7624,
    y2: 22.4923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#FC9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#FE8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#FC9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_675_3936",
    x1: 25.3349,
    y1: -1.40266,
    x2: 52.7514,
    y2: 11.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_675_3936",
    x1: 49.3018,
    y1: 26.7437,
    x2: 49.3018,
    y2: 63.9763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#FC9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#FE8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_675_3936",
    x1: 22.1062,
    y1: 26.7437,
    x2: 22.1062,
    y2: 63.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_675_3936",
    x1: 48.4863,
    y1: 46.1319,
    x2: 48.2635,
    y2: 63.5116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_675_3936",
    x1: 48.307,
    y1: 38.0456,
    x2: 49.0659,
    y2: 51.4893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_675_3936",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.9673 35.5708) scale(34.0938 34.0938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_675_3936",
    x1: 81.6182,
    y1: 3.43579,
    x2: 82.0754,
    y2: 40.4509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#FE6800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#FA9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_675_3936",
    x1: 43.6406,
    y1: 53.5923,
    x2: 53.6229,
    y2: 29.7706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_675_3936",
    x1: 63.8457,
    y1: 54.2233,
    x2: 62.6343,
    y2: 29.5882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_675_3936",
    x1: 127.618,
    y1: 32.6809,
    x2: 72.7102,
    y2: 61.5018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_675_3936",
    x1: 60.9893,
    y1: 52.6305,
    x2: 56.0602,
    y2: 39.2344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE330E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#930000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_675_3936",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.926 25.6121) rotate(9.18163) scale(11.3492 11.3492)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_675_3936",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.0126 51.0757) rotate(11.0842) scale(11.1863 11.1863)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_675_3936",
    x1: 7.80393,
    y1: 43.578,
    x2: 6.29108,
    y2: 50.8261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_675_3936",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.995 10.73) rotate(-2.37968) scale(24.5223 24.5222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_675_3936",
    x1: 61.6256,
    y1: 53.462,
    x2: 55.2476,
    y2: 45.6093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_675_3936",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.1045 -7.43352) rotate(8.90199) scale(14.2618 14.2618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_675_3936",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.1945 7.16524) rotate(8.42702) scale(13.9006 13.9005)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_675_3936",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.529 5.7225) rotate(-155.66) scale(11.7376 11.7376)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_675_3936",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.98 -3.61401) rotate(-157.783) scale(13.0187 13.0187)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_675_3936",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-2.10071 57.2435) rotate(2.58694) scale(13.1687 13.1687)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_675_3936",
    x1: 61.4336,
    y1: 39.29,
    x2: 60.7589,
    y2: 47.3265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlyChallenge);
export default __webpack_public_path__ + "static/media/monthlyChallenge.65a2b7b21254ed4377f2f50cc1a3e1ee.svg";
export { ForwardRef as ReactComponent };